import BreadCrumbTitle from './breadCrumbTitle.vue';

export default BreadCrumbTitle;

export { BreadCrumbTitle };
